<script>
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Components
	import Label from '@/Components/Label.svelte';
	// Constants
	import { EventStatus } from '@/Constants/Event.js';
	import { AlertTypes, AlertLevel } from '@/Constants/Alert.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Stores
	import AlertStore from '@/Stores/AlertStore.js';

	export let race;
	export let meetingId;

	let open = false;

	$: mismatchAlert =
		meetingId &&
		race &&
		$AlertStore &&
		(AlertStore.getAlertForRace(race.id, AlertTypes.RESULT_MISMATCH) ||
			AlertStore.getAlertForMeeting(meetingId, AlertTypes.RESULT_MISMATCH));
	$: unfinalisedAlert =
		meetingId &&
		race &&
		$AlertStore &&
		(AlertStore.getAlertForRace(race.id, AlertTypes.NOT_FINALISED) ||
			AlertStore.getAlertForMeeting(meetingId, AlertTypes.NOT_FINALISED));

	function updateStatus(statusId) {
		RaceStore.updateRaceStatus(race.id, statusId)
			.then(() => {
				notify({
					type: 'success',
					title: `Race ${race.race_number}`,
					message: `Status updated to ${
						statusId === EventStatus.Closed ? 'Closed' : 'Open - NOTE: You must CLOSE the race manually now.'
					}`,
					timeout: 6
				});
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: `Race ${race.race_number}`,
					message: 'Failed to update status',
					timeout: 3
				});
			})
			.finally(() => (open = false));
	}

	function handleKeydown(e) {
		if (e.key === 'Escape' && open) {
			open = false;
			e.preventDefault();
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="relative inline-block">
	{#if [EventStatus.Open, EventStatus.Closed, EventStatus.ReOpened].indexOf(race.status.id) >= 0}
		<button on:click={() => (open = !open)} class="focus:outline-none">
			<Label label={race.status.name} classes="ml-1" />
		</button>
	{:else}
		<div class="flex">
			<span class="relative inline-flex rounded-md shadow-sm">
				{#if unfinalisedAlert}
					<Label label="Unfinalised" classes="bg-red-100" />
					<span class="flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1">
						<span
							class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
							class:bg-blue-400={unfinalisedAlert.level === AlertLevel.None ||
								unfinalisedAlert.level === AlertLevel.Info ||
								unfinalisedAlert.level === AlertLevel.Success}
							class:bg-yellow-400={unfinalisedAlert.level === AlertLevel.Warning}
							class:bg-red-400={unfinalisedAlert.level === AlertLevel.Danger}
						/>
						<span
							class="relative inline-flex rounded-full h-3 w-3"
							class:bg-blue-500={unfinalisedAlert.level === AlertLevel.None ||
								unfinalisedAlert.level === AlertLevel.Info ||
								unfinalisedAlert.level === AlertLevel.Success}
							class:bg-yellow-500={unfinalisedAlert.level === AlertLevel.Warning}
							class:bg-red-500={unfinalisedAlert.level === AlertLevel.Danger}
						/>
					</span>
				{/if}
				{#if mismatchAlert}
					<Label label="Mismatch" classes="bg-red-100" />
					<span class="flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1">
						<span
							class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
							class:bg-blue-400={mismatchAlert.level === AlertLevel.None ||
								mismatchAlert.level === AlertLevel.Info ||
								mismatchAlert.level === AlertLevel.Success}
							class:bg-yellow-400={mismatchAlert.level === AlertLevel.Warning}
							class:bg-red-400={mismatchAlert.level === AlertLevel.Danger}
						/>
						<span
							class="relative inline-flex rounded-full h-3 w-3"
							class:bg-blue-500={mismatchAlert.level === AlertLevel.None ||
								mismatchAlert.level === AlertLevel.Info ||
								mismatchAlert.level === AlertLevel.Success}
							class:bg-yellow-500={mismatchAlert.level === AlertLevel.Warning}
							class:bg-red-500={mismatchAlert.level === AlertLevel.Danger}
						/>
					</span>
				{/if}
			</span>
			<Label label={race.status.name} classes="ml-1 flex-initial" />
		</div>
	{/if}
	{#if open}
		<div class="absolute z-10 pt-2">
			<div class="relative py-1 bg-white border border-gray-300 rounded-md shadow-xl">
				<div
					class="absolute top-0 w-4 h-4 origin-center transform rotate-45 translate-x-5 -translate-y-2 bg-white border-t border-l border-gray-300 rounded-sm pointer-events-none"
				/>
				<div class="relative flex p-2 -mr-4 whitespace-nowrap">
					<div class="mr-4 text-center">
						{#if race.status.id === EventStatus.Closed}
							<button on:click={() => updateStatus(EventStatus.ReOpened)} class="focus:outline-none">
								<Label label="Open" classes="bg-green-500 text-light font-bold" />
							</button>
						{:else}
							<button on:click={() => updateStatus(EventStatus.Closed)} class="focus:outline-none">
								<Label label="Close" classes="bg-red-500 text-light font-bold" />
							</button>
						{/if}
					</div>
				</div>
			</div>
		</div>
	{/if}
</div>
